import { ActionTree }                                       from 'vuex';
import { RootState }                                        from '@/store/store.types';
import i18n                                                 from '@/i18n';
import { HeatMapValues, State }                             from '@/views/heat-map-configuration/heat-map-configuration.types';
import { getHeatMapConfiguration, putHeatMapConfiguration } from '@/views/heat-map-configuration/services/heat-map-configuration.service';
import { Notification }                                     from '@/components/notification/notification';

const actions: ActionTree<State, RootState> = {
  async getHeatMapValues({ commit }): Promise<void> {
    try {
      const { data } = await getHeatMapConfiguration();
      const { options } = data;
      commit('setHeatMapConfiguration', options);
    } catch (e) {
      Notification.error(
        i18n.t('vHeatMapConfiguration.notification.error.title') as string,
        i18n.t('vHeatMapConfiguration.notification.error.getConfiguration') as string,
      );
      throw e;
    }
  },
  async putHeatMapConfiguration({ commit }, payload: HeatMapValues[]): Promise<void> {
    try {
      const { data } = await putHeatMapConfiguration(payload);
      commit('setHeatMapConfiguration', data);
      Notification.success(
        i18n.t('vHeatMapConfiguration.notification.success.title'),
        i18n.t('vHeatMapConfiguration.notification.success.updateConfiguration'),
      );
    } catch (e) {
      Notification.error(
        i18n.t('vHeatMapConfiguration.notification.error.title') as string,
        i18n.t('vHeatMapConfiguration.notification.error.updateConfiguration') as string,
      );
      throw e;
    }
  },
};

export default actions;
